import { useNavigate } from "react-router-dom";
import UserIcon from "../../../assets/icons/header-icons/user-icon.svg";
import {
  LOGIN_ROUTE,
  SIGN_UP_ROUTE,
  useAppDispatch,
  useAppSelector,
} from "@hypexone/uicore";
import HeaderButtonComponent from "./HeaderButtonComponent";
import LoginSection from "./LoginSection";
import { isWhatsappSignup } from "../../../constants/Branding";

const LoginButtons = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { domainConfig } = useAppSelector((state) => state.common);

  // HA signup off + signin on => Sign Up opens the registration WhatsApp link instead of the sign-up page.
  const registrationWhatsappLink = domainConfig?.suppportContacts?.find(
    (ct) => ct.contactType === "REGISTRATION_WHATSAPP_LINK"
  )?.details;
  const whatsappSignup = isWhatsappSignup(domainConfig);
  const showSignUp = whatsappSignup
    ? !!registrationWhatsappLink
    : domainConfig?.signup && domainConfig?.b2cEnabled;

  const handleSignupClick = () => {
    if (whatsappSignup) {
      window.open(registrationWhatsappLink, "_blank");
      return;
    }
    navigate(SIGN_UP_ROUTE);
  };
  const { langData } = useAppSelector((state) => state.cms);

  return (
    <div className="flex items-center gap-1">
      <img src={UserIcon} alt="user-icon" className="hidden md:block h-3 w-3" />

      <LoginSection isHeader />

      <div className="flex md:hidden items-center gap-1">
        {showSignUp && (
          <HeaderButtonComponent
            onClick={handleSignupClick}
            buttonText={
              whatsappSignup ? langData?.["sign_in"] || "Sign In" : langData?.["sign_up"]
            }
            customCSS="rounded text-sm bg-button-gradient"
          />
        )}
        {/* { (domainConfig?.b2cEnabled ||  domainConfig?.demoUser) && <HeaderButtonComponent 
          onClick={() => dispatch(handleDemoLogin(navigate))}
          buttonText={"Demo"}
        />} */}
        <HeaderButtonComponent
          leftIcon={{ src: UserIcon, alt: "user-icon" }}
          onClick={() => navigate(LOGIN_ROUTE, { replace: true })}
          buttonText={langData?.["login"]}
          customCSS="bg-custom-red-gradient text-white rounded"
        />
      </div>
    </div>
  );
};

export default LoginButtons;
